import { capitalize } from 'lodash';
import React from 'react';
import { Text } from '../../../globalStyles';
import { CampusResourcesQuery } from '../../../graphQL';

type Resource = CampusResourcesQuery['organization']['resources'][number];

type ResourceDisplayProps = {
  resource: Resource;
};

export const ResourceDisplay = ({ resource }: ResourceDisplayProps) => {
  const listedKeys: (keyof Resource)[] = [
    'contact',
    'location',
    'phone',
    'email',
    'hours',
    'website',
  ];

  return (
    <div className="mr2 mb4">
      <Text.bodyBold>{resource.name}</Text.bodyBold>
      <Text.body className="mb3" style={{ whiteSpace: 'pre-wrap' }}>
        {resource.description}
      </Text.body>
      {listedKeys
        .filter(fieldKey => !!resource[fieldKey])
        .map(fieldKey => (
          <Text.body key={fieldKey}>
            <span className="b">{capitalize(fieldKey)}:</span> {resource[fieldKey]}
          </Text.body>
        ))}
    </div>
  );
};
